import { Injectable, computed, signal } from '@angular/core';

/**
 * Tracks in-flight studio-API requests so the shell can show a single global
 * loading affordance (a slim top progress bar) instead of each page rendering
 * its own detached spinner. Fed by LoadingInterceptor; read by the shell.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly count = signal(0);

  /** True while one or more tracked requests are in flight. */
  readonly active = computed(() => this.count() > 0);

  start(): void {
    this.count.update((c) => c + 1);
  }

  stop(): void {
    this.count.update((c) => Math.max(0, c - 1));
  }
}
